const EVENT_TYPES = {
  STOP: 'stop',
  INIT: 'init',
  PING: 'ping',
  PONG: 'pong',
};

const PING_INTERVAL = 200;
const PONG_THRESHOLD = 3;

const Client2DSDK = (contId, clientPlayerLink, payload, language) => {
  const _containerId = contId;
  const _playerLink = clientPlayerLink;
  const _payload = payload;
  const _language = language;
  const _targetOrigin = (new URL(_playerLink)).origin;
  let _onCanReceiveMessageCallback;
  let _pingIntervalRef;
  let _pongCount = 0;

  const _handleMessage = (event) => {
    const { type } = event.data;
    switch (type) {
      case EVENT_TYPES.STOP:
        break;
      case EVENT_TYPES.PONG:
        _pongCount++;
        if (_onCanReceiveMessageCallback && _pongCount >= PONG_THRESHOLD) {
          _onCanReceiveMessageCallback();
          clearInterval(_pingIntervalRef);
          _pongCount = 0;
        }
        break;
      default:
        break;
    }
  };

  const _onload = () => {
    console.log('Client Player: loaded');
    window.addEventListener('message', _handleMessage);
  };

  const _createIframe = () => {
    const container = document.getElementById(_containerId);

    if (!container) {
      throw 'Cannot find the container';
    }

    // Create the iframe element.
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', _playerLink);
    iframe.setAttribute('id', '2d-sdk-iframe');
    iframe.setAttribute('allow', 'fullscreen');
    iframe.setAttribute('title', '2d-experience-iframe');

    iframe.style.width = '100%';
    iframe.style.height = '100%';

    container.appendChild(iframe);

    iframe.onload = _onload;

    return iframe;
  }

  const _postMessage = (data) => {
    _iframe.contentWindow.postMessage(data, _targetOrigin);
  };

  const _initialize = (consumablePayload, selectedLanguadeCode) => {
    _postMessage({ type: EVENT_TYPES.INIT, value: consumablePayload, language: selectedLanguadeCode });
    console.log('Client Player: initialized, language is ', selectedLanguadeCode);
  };

  const _iframe = _createIframe();

  return {
    get: () => {
      return _iframe;
    },
    initialize: _initialize,
    postSDKMessage: (data) => {
      _postMessage(data);
    },
    onCanReceiveMessage: (callback) => {
      _onCanReceiveMessageCallback = callback;
      _pingIntervalRef = setInterval(() => {
        _postMessage({ type: EVENT_TYPES.PING });
      }, PING_INTERVAL);
    },
    cleanup: () => {
      window.removeEventListener('message', _handleMessage);
      clearInterval(_pingIntervalRef);
    },
    stop: () => {
      _postMessage({ type: EVENT_TYPES.STOP });
    },
  };
};

export default Client2DSDK;
